export default "__VITE_ASSET__04586e1d__"